import { TitleKeys } from 'pages/ParentHelper/components/History/components/Content/types';
import { scrollIntoView } from 'shared/utils/dom';

export const scrollToToday = () => {
  setTimeout(() => scrollIntoView(document.getElementById(TitleKeys.Today)));
};
